import { render, staticRenderFns } from "./MoleculeEditionBillingAcademyMigrationSearchSale.vue?vue&type=template&id=68a4c488"
import script from "./MoleculeEditionBillingAcademyMigrationSearchSale.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademyMigrationSearchSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports